import { render, staticRenderFns } from "./RecipientInfo.vue?vue&type=template&id=06ff098d&scoped=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipientInfo.vue?vue&type=style&index=0&id=06ff098d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff098d",
  null
  
)

export default component.exports